// Note: this file is temporary and will be removed on A/B test conclusion

export const LESA_NO_ANSWER_AGENT_HANDOFF_VARIATION = 'agent_handoff'

export const LESA_NO_ANSWER_PHONE_NUMBER_CLICK_EVENT = {
  key: 'lesa_no_answer_support_number_click',
  optimizelyEventId: '5401473951989760',
} as const

export const LESA_NO_ANSWER_AGENT_HANDOFF_CLICK_EVENT = {
  key: 'lesa_no_answer_connect_to_agent_pill_click',
  optimizelyEventId: '4995682690400256',
} as const

export function isDefaultNoAnswerResponse(payload?: App.ChatMessageMetaPayload) {
  return payload?.isDefaultNoAnswerResponse === true
}
